import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';

import { NcButton } from '../NcButton';

export type NcLinkStyledAsButtonPropsT = {
  buttonText: string;
  to: string;
  fullWidth?: boolean;
};
export type NcLinkStyledAsButtonT = React.FC<NcLinkStyledAsButtonPropsT>;

export const NcLinkStyledAsButton: NcLinkStyledAsButtonT = ({
  buttonText,
  fullWidth,
  to,
}) => (
  <NcButton
    as="a"
    href={to}
    variant="primary"
    className={mergeClassNameStrings(fullWidth && 'w-100')}
  >
    {buttonText}
  </NcButton>
);
